import "core-js/modules/es.array.map.js";
import React from 'react';
import { _QuestionContainer, _QuestionTitle, _QuestionResponse, _Bullet } from "./style";
var StudentRecordQuestion = function StudentRecordQuestion(_ref) {
  var question = _ref.question;
  return /*#__PURE__*/React.createElement(_QuestionContainer, null, /*#__PURE__*/React.createElement(_QuestionTitle, null, question.attributes.question), question.attributes.question_format === 'checkboxes' ? JSON.parse(question.attributes.answers[0].answer).map(function (selection, index) {
    return /*#__PURE__*/React.createElement(_QuestionResponse, {
      key: index
    }, /*#__PURE__*/React.createElement(_Bullet, null, selection));
  }) : /*#__PURE__*/React.createElement(_QuestionResponse, null, question.attributes.answers[0].answer));
};
export default StudentRecordQuestion;